import axios from "axios";
const pond2 = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}api/v1/content/point2`
    );
    return response.data;
  } catch (error) {
    console.log(process.env.REACT_APP_BACKEND_URL);
    console.error("Error saving data:", error);
    // console.clear();
    throw error;
  }
};

export default pond2;
